import { BaseModel } from "./hateoas/base-model";

export class DestinyAnalysisModel extends BaseModel {
  idUser?: number;
}
